import '@fontsource/lato/latin-400.css';
import '@fontsource/lato/latin-700.css';
import '@fontsource/lato/latin-700-italic.css';
import './_Layout.scss';

import { findLast, uniqBy } from 'lodash';
import { graphql, useStaticQuery } from 'gatsby';

import Footer from '../../../../components/Layout/Footer';
import Layout from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Layout/Layout';
import React from 'react';
import SiteHeader from '../../../../components/Layout/SiteHeader';
import { usePageLocalization } from '@sbi-international/boutik.gatsby.plugin.multilocale';

export default function _Layout(props) {
    const { currentLocale } = usePageLocalization();
    const ventings = useStaticQuery(
        graphql`
            query {
                venting: allProductsJson(
                    filter: { category: { regex: "^/OCC/Venting/" } }
                ) {
                    nodes {
                        id
                        code
                        category
                        category_localized {
                            en_CA
                            en_US
                            fr_CA
                        }
                        title {
                            en_CA
                            en_US
                            fr_CA
                        }
                        slug {
                            en_CA
                            en_US
                            fr_CA
                        }
                        description {
                            en_CA
                            en_US
                            fr_CA
                        }
                        images
                        documents {
                            en_CA
                            en_US
                            fr_CA
                        }
                        fields {
                            ...productsFieldsImagesFragment                     
                        }
                        attributes {
                            custom_made {
                                values {
                                    en_CA
                                    en_US
                                    fr_CA
                                }
                            }
                            diameter {
                                values {
                                    en_CA
                                    en_US
                                    fr_CA
                                }
                            }
                        }
                    }
                }
                catalogs: allProductsJson(
                    filter: { code: {regex: "/occ_catalogue-\\S+/"} }
                ) {
                    nodes {
                        code
                        title {
                            en_CA
                            en_US
                            fr_CA
                        }
                        description {
                            en_CA
                            en_US
                            fr_CA
                        }
                        documents {
                            en_CA
                            en_US
                            fr_CA
                        }
                        attributes {
                            available_country {
                              values {
                                fr_CA
                                en_US
                                en_CA
                              }
                            }
                          }
                    }
                }
            }
        `
    );
    const pathIndex = 3;
    const products = ventings.venting.nodes;
    let allCategories = products.map((product) => {
        let categoryPathLocalized =
            product!.category_localized[currentLocale].split('/');
        let categoryPath = product.category.split('/');
        return {
            id: product.category_localized[currentLocale],
            name: findLast(categoryPathLocalized, (x) => x.length > 0),
            url_name: findLast(categoryPath, (x) => x.length > 0)
                .split(' ')
                .join('-')
                .replace('&', 'and'),
            type: categoryPathLocalized?.[pathIndex],
            code: product.category_localized['en_CA']
                .split('/')
                [pathIndex].split(' ')
                .join('-'),
            diameter: product?.attributes?.diameter?.values[0][currentLocale],
            url: categoryPath?.[pathIndex].toLowerCase().split(' ').join('-'), // équivalent à replaceAll(' ', '-'), fix build gatsby
        };
    });

    let categoryTypes = uniqBy(allCategories, 'type').sort((a: any, b: any) =>
        a.type > b.type ? 1 : -1
    );

    const catalogs = ventings.catalogs.nodes;

    return (
        <>
            <SiteHeader
                categoryTypes={categoryTypes}
                allCategories={allCategories}
            />
            <Layout {...props} />
            <Footer categoryTypes={categoryTypes} catalogs={catalogs} />
        </>
    );
}
